import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";

import { initialValues, schema } from "../../../../constants/forms/experience/edit";
import Link from "../../../../components/Link";
import Submit from "../../../../components/FormikForm/Submit";
import { useLayout } from "../../../../providers/LayoutProvider";
import Grid from "../../../../components/Grid"
import { getGroupById, resetUpdateGroup, updateGroup } from "../../../../store/actions/group";
import { hideModal, showModal } from "../../../../store/actions/modal";
import services from "../../../../services";
import { getGroupsFilePath } from "../../../../services/storage";
import { NewFileInDto } from "../../../../types/storage.dto";
import Snackbar from "../../../../components/Snackbar";
import Congratulations from "../../components/ModalCongratulations";
import Form from "../../components/GroupForm"
import { useFileUploadProgress } from "../../../../providers/FileUploader";
import { inputDateTimeLocal, setToZeroTimeZone } from "../../../../helpers/dates-hanlder";
import Loader from "../../../../components/LogoLoader";
import { getUrlParamByName } from "../../../../helpers/get-url-param";


const Component = ({ match, updateGroupStates, updateGroupData, userInformation, groupInformation, groupInformationStates }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { layout, setLayout } = useLayout();
  const timestamp = new Date().getTime();
  const [formSubmmited, setFormSubmmited] = useState(false);
  const { uploadFiles, resetFileUploadProgress } = useFileUploadProgress();
  const [isRecordedExperience, setIsRecordedExperience] = useState(false)

  const onSubmit = async ({ values, actions }) => {
    const thereAreFilesToUpload = values && (values.cover_pic?.some(file => file instanceof File) || values.group_video?.some(file => file instanceof File));

    if (thereAreFilesToUpload) {
      dispatch(showModal("modal-wait-a-minute-bis"));
    }

    try {
      if (thereAreFilesToUpload) {
        const uploadedFiles = await uploadFiles(
          {
            cover_pic: values.cover_pic,
            group_video: values.group_video,
          },
          userInformation.id,
          "group"
        );

        const updatedValues = {
          ...values,
          ...(!isRecordedExperience ? {
            registration_closing_date: setToZeroTimeZone(
              values.registration_closing_date
            ),
            duration_unit: values.duration_unit,
            duration: values.duration,
          } : {
            registration_closing_date: null,
            duration: null,
            duration_unit: null
          }),
          cover_pic: uploadedFiles?.cover_pic && uploadedFiles?.cover_pic.length >= 0 ? uploadedFiles?.cover_pic[0] : null,
          group_video: uploadedFiles?.group_video ? uploadedFiles?.group_video[0] : null
        };

        dispatch(updateGroup(updatedValues));
      } else {
        // If there are no files to upload, dispatch update directly
        const updatedValues = {
          ...values,
          ...(!isRecordedExperience ? {
            registration_closing_date: setToZeroTimeZone(
              values.registration_closing_date
            ),
            duration_unit: values.duration_unit,
            duration: values.duration,
          } : {
            registration_closing_date: null,
            duration: null,
            duration_unit: null
          }),
          cover_pic: values?.cover_pic && values?.cover_pic[0] ? values?.cover_pic[0] : null,
          group_video: values?.group_video && values?.group_video[0]? values?.group_video[0] : null
        };

        dispatch(updateGroup(updatedValues));
      }
    } catch (error) {
      console.error('Error during file uploads:', error);
    } finally {
      dispatch(hideModal());
    }
  }

  useEffect(() => {
    if (!!updateGroupStates && updateGroupStates.success) {
      setTimeout(() => {
        const groupId = updateGroupData?.id;
        dispatch(resetUpdateGroup());
        resetFileUploadProgress();
        dispatch(hideModal());
        history.push(`/dashboard/experience/${groupId}`);
      }, 3500);
    }
  }, [updateGroupStates, updateGroupData]);

  useEffect(() => {
    if (match?.params?.idGroup && (!groupInformation || (!!groupInformation && groupInformation?.id !== Number(match?.params?.idGroup)))) {
      dispatch(getGroupById({ group_id: match.params.idGroup }))
    }
  }, [match])

  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title: "Editar taller 🙏✨",
        description: "Editar taller",
        back: `/dashboard/experience/list`,
      },
      dashboard: {
        tabs: {
          visible: false,
        },
      },
      header: {
        visible: true,
        actions: [
          <Submit
            isSubmmiting={updateGroupStates.loading}
            options={{
              type: "filled",
              size: "lg",
              skin: "purple",
            }}
            form="edit-experience-form"
          >
            Editar taller
          </Submit>,
        ],
      },
    });
  }, []);

  useEffect(() => {
    !!groupInformation && setIsRecordedExperience(groupInformation?.recorded || false);
  }, [groupInformation])

  if (!groupInformation || groupInformationStates.loading) {
    return <Loader />;
  }

  return (
    <Grid.Container>
      <Grid.Row>
        <Grid.Col sm={6}>
          <Formik
            initialValues={{
              ...initialValues,
              ...groupInformation,
              group_video: groupInformation?.group_video ? [groupInformation?.group_video] : [],
              cover_pic: groupInformation?.cover_pic ? [groupInformation?.cover_pic] : [],
              ...(!groupInformation?.recorded && {
                registration_closing_date: inputDateTimeLocal(
                  groupInformation.registration_closing_date
                ),
              }),
              recorded: isRecordedExperience
            }}
            onSubmit={(values, actions) => {
              if (onSubmit) onSubmit({ values, actions });
            }}
            validateOnChange={false}
            validateOnBlur={formSubmmited}
            validationSchema={schema({isRecordedExperience})}
            enableReinitialize
          >
            {({
              values,
              errors,
              touched,
              setFieldValue,
              setFieldError,
              setFieldTouched,
              handleChange,
              handleBlur,
              handleReset,
              handleSubmit,
            }) => {
              return (
                <form
                  className="theme-form"
                  onSubmit={(event) => {
                    setFormSubmmited(true);
                    handleSubmit(event);
                  }}
                  id="edit-experience-form"
                >
                  <Form
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    setFieldTouched={setFieldTouched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    isEdition
                    isRecordedExperience={isRecordedExperience}
                  />
                </form>
              );
            }}
          </Formik>
        </Grid.Col>
      </Grid.Row>

      <div style={{ height: 40 }} />

      <Grid.Row>
        <Grid.Col>
          <Link
            style={{ marginRight: "8px" }}
            options={{
              type: "outline",
              size: "lg",
              skin: "purple",
              native: true,
            }}
            href="/dashboard/experience/list"
          >
            Cancelar
          </Link>

          <Submit
            isSubmmiting={updateGroupStates.loading}
            options={{
              type: "filled",
              size: "lg",
              skin: "purple",
            }}
            form="edit-experience-form"
          >
            Editar taller
          </Submit>
        </Grid.Col>
      </Grid.Row>

      <Congratulations page="Experiencia" />

      <Snackbar
        visible={updateGroupStates.success || !!updateGroupStates.error}
        options={{
          time: 2000,
          type: updateGroupStates.success ? "success" : "error",
        }}
      >
        {updateGroupStates.success
          ? "Taller editado."
          : "Error al editar el taller."}
      </Snackbar>

      <div style={{ height: "50px" }} />
    </Grid.Container>
  )
}

const state = ({ carouselStore, groupStore, userStore }) => {
  const { data: userInformation } = userStore.information;
  const { data: userGroups, states: userGroupsStates } = userStore.groups;
  const { currentSlide } = carouselStore;
  const { data: updateGroupData, states: updateGroupStates } = groupStore.updateGroup;
  const { data: groupInformation, states: groupInformationStates } = groupStore.group;

  return {
    currentSlide,
    updateGroupStates,
    updateGroupData,
    userInformation,
    userGroups,
    userGroupsStates,
    groupInformation,
    groupInformationStates
  };
};

export default connect(state)(Component);